module.exports = __webpack_public_path__ + "f563a570101278f1ada0f3df11ec0992.png";